const DOMSelector = {
  widgetWrapper: 'div[id][data-civicscience-widget],div[id][data-civicscience-portal]'
};

export default DOMSelector;
